import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const OverlayWrapper = styled.div<IThemeProps>`
  position: relative;
  width: 100%;
  max-width: 540px;
  background: #ffffff;
  z-index: ${(props: IThemeProps) => props.theme.zIndex.h300};
  border: 3px solid ${(props: IThemeProps) => props.theme.colors.primary};
  padding: ${(props: IThemeProps) => props.theme.spacing.desktop.s500}px;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    width: 95vw;
    padding: ${(props: IThemeProps) => props.theme.spacing.desktop.s200}px;
  }
`;

export const OverlayContent = styled.div<{ hasTopPadding: boolean }>`
  width: 100%;
  padding-top: ${(props: any) =>
    props.hasTopPadding ? props.theme.spacing.desktop.s800 : 0}px;
`;

export const OverlayClose = styled.div<IThemeProps>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  padding: ${(props: IThemeProps) => props.theme.spacing.desktop.s100}px;
  margin: ${(props: IThemeProps) => props.theme.spacing.desktop.s200}px;
  color: ${(props: IThemeProps) => props.theme.colors.black};
  background-color: transparent;
  cursor: pointer;
  text-align: center;
  z-index: ${(props: IThemeProps) => props.theme.zIndex.h500};

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    padding: 0;
    svg {
      padding: 3px;
    }
  }
`;

export const OutroFeedback = styled.div`
  position: relative;
  text-align: center;
  h3 {
    margin-top: ${(props: any) => props.theme.spacing.desktop.s500}px;
    margin-bottom: ${(props: any) => props.theme.spacing.desktop.s500 * 2}px;
    font-size: ${(props: any) => props.theme.typography.h700};
  }
`;

export const OutroFeedbackIcon = styled.div<{ success: boolean }>`
  display: inline-flex;
  padding: ${(props: any) => props.theme.spacing.desktop.s200}px;
  background-color: ${(props: any) =>
    props.success ? props.theme.colors.success : props.theme.colors.error};
`;

export const LightContainer = styled.div`
  background-color: white;
  max-width: 600px;
  padding: 24px;
  border-radius: 4px;
  box-sizing: border-box;
`;

export const LightIconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  cursor: pointer;
`;
